import { getOktaAccessToken } from "../LocalStorage";
import { request } from "./Api";

const BANK_ACCOUNT_API_URL = process.env.REACT_APP_BANK_ACCOUNT_API_BASE_URL;
const getAllParentAccounts = (): Promise<any> => {
  const token = getOktaAccessToken();

  if (!token) {
    return Promise.reject("Missing Token");
  }

  return request({
    method: "GET",
    url: BANK_ACCOUNT_API_URL + "/parent-accounts",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return response;
    })
    .catch((error: string) => {
      error = "Could Not Retrieve List of Parent Accounts";
      throw error;
    });
};

const getUnitDepositoryParentAccounts = (
  accountsToFetch: any
): Promise<any> => {
  const token = getOktaAccessToken();

  if (!token) {
    return Promise.reject("Missing Token");
  }

  return request({
    method: "GET",
    url: BANK_ACCOUNT_API_URL + "/parent-accounts",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: { queryTypeEnum: accountsToFetch },
  })
    .then((response) => {
      return response;
    })
    .catch((error: string) => {
      error = "Could Not Retrieve List of Parent Accounts";
      throw error;
    });
};

const getParentAccountTypes = (): Promise<any> => {
  const token = getOktaAccessToken();

  if (!token) {
    return Promise.reject("Missing Token");
  }

  return request({
    method: "GET",
    url: BANK_ACCOUNT_API_URL + "/parent-accounts/account-types",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return response;
    })
    .catch((error: string) => {
      error = "Could not retrieve Parent Account Types";
      throw error;
    });
};

const saveAllParentAccounts = (ParentAccounts: any): Promise<any> => {
  const token = getOktaAccessToken();

  if (!token) {
    return Promise.reject("Missing Token");
  }

  return request({
    method: "POST",
    url: BANK_ACCOUNT_API_URL + "/parent-accounts",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: ParentAccounts,
  })
    .then((response) => {
      return response;
    })
    .catch((error: string) => {
      throw error;
    });
};

export {
  getAllParentAccounts,
  getParentAccountTypes,
  saveAllParentAccounts,
  getUnitDepositoryParentAccounts,
};
